import { Button } from "@material-ui/core";
import { Divider } from "@mui/material";
import {
  DataGrid,
  GridCellEditCommitParams,
  GridRenderCellParams,
} from "@mui/x-data-grid";
import SearchBar from "material-ui-search-bar";
import React, { useEffect, useState } from "react";
import { useAlert } from "react-alert";
import { useNavigate, useParams } from "react-router-dom";
import { Axios } from "../../App";
import styles from "../../styles/Datatable.module.scss";
import * as FaIcons from "react-icons/fa";

type DataType = {
  id: string;
  participant_name: string;
  number_of_additional_guests: number;
  note: string;
  is_participated: string;
  field1: string;
  field2: string;
  field3: string;
};

type TProps = {
  fontColor: string;
};

const DataTable: React.FC<TProps> = ({ fontColor }) => {
  const alert = useAlert();
  const { id } = useParams();
  const [originalRows, setOriginalRows] = useState<DataType[]>([]);
  const [rows, setRows] = useState<DataType[]>(originalRows);
  const [searched, setSearched] = useState<string>("");
  const [selectedRows, setSelectedRows] = useState<DataType[]>([]);
  const [columns, setColumns] = useState<[]>([]);
  const navigate = useNavigate();

  const setIsParticipated = () => {
    selectedRows.map((item: DataType) => {
      Axios.post("participants/setIsParticipated.php", {
        id: item.id,
      })
        .then(({ data }) => {
          if (!data.success) throw new Error("The fetch was not successful.");
          getAllByID();
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch((e) => {
          console.error(e);
        });
    });
  };

  const setHeader = (firstRowOfDatabase: DataType) => {
    let array = [] as any;
    if (!firstRowOfDatabase) {
      setColumns(array);
      return;
    }
    array.push(
      {
        field: "is_participated",
        headerName: "Résztvevő?",
        renderCell: (params: GridRenderCellParams) => {
          return params.value === 1 ? (
            <FaIcons.FaCheck color="darkGreen" />
          ) : (
            <FaIcons.FaTimes color="red" />
          );
        },
      },
      {
        field: "participant_name",
        headerName: firstRowOfDatabase?.participant_name || "Név",
        editable: true,
        minWidth: 400,
      },
      {
        field: "number_of_additional_guests",
        headerName: "HVSZ",
        editable: true,
        width: 50,
      },
      {
        field: "note",
        headerName: firstRowOfDatabase?.note || "Megjegyzés",
        editable: true,
        minWidth: 400,
      }
    );
    if (firstRowOfDatabase?.field1) {
      array.push({
        field: "field1",
        headerName: firstRowOfDatabase?.field1 || "Mező",
        editable: true,
        minWidth: 400,
      });
    }
    if (firstRowOfDatabase?.field2) {
      array.push({
        field: "field2",
        headerName: firstRowOfDatabase?.field2 || "Mező 2",
        editable: true,
        minWidth: 400,
      });
    }
    if (firstRowOfDatabase?.field3) {
      array.push({
        field: "field3",
        headerName: firstRowOfDatabase?.field3 || "Mező 3",
        editable: true,
        minWidth: 400,
      });
    }
    setColumns(array);
  };

  const getAllByID = () => {
    Axios.post("participants/getAllByID.php", {
      id: id,
    })
      .then(({ data }) => {
        setHeader(data[0]);
        data.shift();
        setOriginalRows(data);
        setRows(data);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const updateParticipant = ({
    id,
    participant_name,
    number_of_additional_guests,
    note,
    field1,
    field2,
    field3,
  }: {
    id: string;
    participant_name: string;
    number_of_additional_guests: number;
    note: string;
    field1: string;
    field2: string;
    field3: string;
  }) => {
    if (isNaN(number_of_additional_guests)) {
      alert.error("A vendégek száma csak szám lehet.");
      return;
    }
    Axios.post("participants/updateParticipant.php", {
      id: id,
      participant_name: participant_name,
      number_of_additional_guests: number_of_additional_guests,
      note: note,
      field1: field1,
      field2: field2,
      field3: field3,
    })
      .then(({ data }) => {
        if (!data.success) throw new Error("Valami nem stimmel");
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const requestSearch = (searchedVal: string) => {
    // const filteredRows = originalRows.filter((row) => {
    //   return row.participant_name.toLowerCase().includes(searchedVal.toLowerCase());
    // });

    const filteredRows = originalRows.filter((row) => {
      return (
        row.participant_name
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .includes(
            searchedVal
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
          ) ||
        row.note
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .includes(
            searchedVal
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
          ) ||
        row.field1
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .includes(
            searchedVal
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
          ) ||
        row.field2
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .includes(
            searchedVal
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
          ) ||
        row.field3
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .includes(
            searchedVal
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
          )
      );
    });
    setRows(filteredRows);
  };

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };

  useEffect(() => {
    const getQueries = async () => {
      getAllByID();
    };

    getQueries();
  }, []);

  const handleCellEditCommit = (params: GridCellEditCommitParams) => {
    const array = rows.map((r) => {
      if (r.id === params.id) return { ...r, [params.field]: params.value };
      else return { ...r };
    });

    setRows(array);
    setOriginalRows(array);

    let result = rows.filter((obj: any) => {
      return obj.id === params.id;
    });
    const dataForInsert = { ...result[0], [params.field]: params.value };

    updateParticipant(dataForInsert);
  };

  return (
    <div>
      <SearchBar
        className={styles.searchBar}
        value={searched}
        onChange={(searchVal) => requestSearch(searchVal)}
        onCancelSearch={() => cancelSearch()}
        placeholder="Keresés"
      />

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Button
          variant="contained"
          color="primary"
          disabled={!selectedRows.length}
          onClick={setIsParticipated}
        >
          Vendég regisztrálás
        </Button>
        <Button
          variant="contained"
          color="default"
          onClick={() => navigate(`/${id}/add-new-participant`)}
        >
          Résztvevő hozzádása
        </Button>
      </div>
      <Divider sx={{ m: 2 }} />
      <>Kijelötek száma: {selectedRows.length}</>
      <Divider sx={{ m: 2 }} />
      <div className={styles.dataGridWrapper}>
        <DataGrid
          // @ts-ignore
          getRowClassName={(params) => {
            if (Number(params.row.is_participated) === 1)
              return "isParticipated";
          }}
          className={styles.dataGrid}
          rows={rows}
          columns={columns}
          pageSize={50}
          rowsPerPageOptions={[50]}
          checkboxSelection
          sx={{
            boxShadow: 2,
            border: 2,
            borderColor: fontColor,
            color: fontColor,
            ".MuiTablePagination-root": {
              color: fontColor,
            },
            ".MuiButtonBase-root": {
              color: fontColor,
            },
            overflowX: "scroll",
          }}
          onSelectionModelChange={(ids) => {
            const selectedIDs = new Set(ids);
            const selectedRows = rows.filter((row) => selectedIDs.has(row.id));
            setSelectedRows(selectedRows);
          }}
          disableSelectionOnClick
          onCellEditCommit={(params) => handleCellEditCommit(params)}
        />
      </div>
    </div>
  );
};

export default DataTable;
